__turbopack_context__.v({
  "address": "Map-module-scss-module__4d61ra__address",
  "frame": "Map-module-scss-module__4d61ra__frame",
  "loading": "Map-module-scss-module__4d61ra__loading",
});
